import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Card, CardContent, Grid, Button, Input, Tooltip, Checkbox, Radio, RadioGroup, FormControlLabel, Backdrop, CardActionArea, TextField, LinearProgress } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
// import { MuiPickersUtilsProvider, } from '@material-ui/pickers';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { useNavigate } from 'react-router-dom';
import Moment from 'moment';
import { toast } from 'react-toastify';
import { sendNotif } from '../redux/ActionCreator';
import { getCurrentDate } from '../functions/current';
// import DateFnsUtils from '@date-io/date-fns';
import { useSelector, useDispatch } from 'react-redux';
import CorouselImages from '../customComponents/carouselImages';
import config from '../config.json';
import { useParams } from 'react-router-dom';

const PREFIX = 'singleEvent';


const classes = {
  backdrop: `${PREFIX}-backdrop`,
  menuButton: `${PREFIX}-menuButton`
};

const Root = styled('div')(({theme}) => ({
  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 10,
    color: '#fff',
    padding: '5vw'
  },

  [`& .${classes.menuButton}`]: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 800,
    fontSize: 20,
    marginTop: 24,
    color: '#ffffff',
    width: 100,
    textTransform: 'none',
    borderRadius: 20,
  }
}));

const token = localStorage.getItem('token');
const userID = parseInt(localStorage.getItem('userID'));
const userFirstName = localStorage.getItem('first_name');

export default function SingleEvent(){

  const members = ([]);
  const [selected, setSelected] = useState([]);
  const [selectedReceivers, setSelectedReceivers] = useState([])
  const checkedState = ([]);
  const receiverCheckedSate = ([]);
  const [email, setEmail] = useState([]);
  const [name, setName] = useState([]);
  const [cred, setCred] = useState([]);
  const [data, setData] = useState([]);
  const [mod, setMod] = useState([]);
  const [All, setAll] = useState(true);
  const [allReceivers, setAllReceivers] = useState(true);
  const navigate = useNavigate();

  const { id } = useParams();
  const [value, setValue] = useState('');
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open5, setOpen5] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [open6, setOpen6] = React.useState(false);
  const [open7, setOpen7] = React.useState(false);
  const [open8, setOpen8] = React.useState(false);
  const [openReceiver, setOpenReceiver] = useState(false);
  const dispatch = useDispatch();
  const stringifiedUser = localStorage.getItem('user');
  const user = JSON.parse(stringifiedUser);
  const act = useSelector((state) => state.activity.activity);
  const [creds, setCreds] = useState(0);
  const [debits, setDebits] = useState(0);
  const [message, setMessage] = useState('');
  const [disable, setDisable] = React.useState(false);
  const [file, setFile] = useState(null);
  const [isRecurring, setisRecurring] = useState(false);
  const [eventID, setEventId] = useState(0);
  const [programid, setProgramId] = useState(0);
  const [volCount, setVolCount] = useState(0)
  const [recCount, setRecCount] = useState(0)
  const [totalCredExchange, setTotalCredExchange] = useState(0)
  const [isLoading, setisLoading] = useState(true);
  const [volunteers, setVolunteers] = useState([]);
  const [receivers, setReceivers] = useState([]);

  const handleChange1 = (event) => {
    setValue(event.target.value);
  };

  // const creditEvent = (creds, earn_or_burn, id) => {
  //   //console.log('hello');

  //   fetch(process.env.REACT_APP_API_URL + '/api/event/credit', {
  //     method: 'PUT',
  //     headers: {
  //       Authorization: `Token ${token}`,
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify({
  //       userID: userID,
  //       type: earn_or_burn,
  //       creds: creds,
  //       eventID: id,
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       //console.log(data);
  //       if (data['status'] === 'success') {
  //         toast.success('Credit$ exchanged');
  //         window.location.reload();
  //       } else {
  //         toast.error('Insufficient Creds');
  //       }
  //     });
  // };

  const handleChange = (e) => {
    //console.log(formData);

    updateFormData({
      ...formData,
      // Trimming any whitespace
      [e.target.name]: e.target.value.trim(),
    });
  };

  const zoom_call_debit = () => {
    fetch(process.env.REACT_APP_API_URL + '/api/excel/debit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        creds: cred,
        users: email,
        moderators: mod,
      }),
    }).then((data) => {
      //console.log(data);
      window.location.reload();
    });
  };

  const addModerator = (index) => {
    //console.log(mod);
    const temp = mod;

    if (!mod.includes(index)) {
      temp.push(index);
      //console.log('here');
    } else {
      temp.splice(index, 1);
    }
    setMod(temp);
    //console.log(temp);
  };

  const [inputList, setInputList] = useState([
    {
      creds: '0',
      clocked_hours: '',
      message: '',
      date: '',
      from_user: userID,
      to_user: 1,
      program: id,
      from_username: 'aditya',
      notif_type: '1',
    },
  ]);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    //console.log(inputList);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleAddClick = () => {
    setInputList([
      ...inputList,
      {
        creds: '0',
        clocked_hours: '',
        program_name: act['title'],
        message: '',
        date: '',
        from_user: userID,
        to_user: 1,
        program: id,
        from_username: user['first_name'] + user['last_name'],
        notif_type: '1',
      },
    ]);
  };
 
  const initialFormData = Object.freeze({
    title: '',
    date: '',
    start_time: '',
    end_time: '',
    is_recurring: '',
  });
  const [formData, updateFormData] = useState(initialFormData);
  // const deleteEvent = (id) => {
  //   fetch(process.env.REACT_APP_API_URL + `/api/act/event`, {
  //     method: 'DELETE',
  //     headers: {
  //       Authorization: `Token ${token}`,
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify({
  //       id: id,
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       //console.log(data);
  //       window.location.reload();
  //     });
  // };

  const getReportList = () => {

    const formData = new FormData();
    formData.append('excel_file', file, file.name);
    //console.log(formData);
    fetch(process.env.REACT_APP_API_URL + `/api/excel/${act['id']}/1`, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data);

        setFile(null);
        handleToggle7();
        setEmail(data['excel_email']);
        setName(data['excel_names']);
        setCred(data['excel_creds']);
      });
  };

  const CreateEvent = () => {
    const body = {
      title: formData.title,
      date: formData.date,
      start_time: formData.start_time,
      end_time: formData.end_time,
      is_recurring: isRecurring,
      program: act['id'],
      creds: formData.creds,
      earn_or_burn: value,
    };
    // console.log(body);
    fetch(process.env.REACT_APP_API_URL + '/api/act/event', {
      method: 'POST',
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        toast.success('Event Added');
      });
  };

  const handleClose = () => {
    setOpen(false);
    setOpen2(false);
    setOpen4(false);
    setOpen5(false);
  };

  const handleToggle2 = () => {
    setOpen2(!open);
  };
  const handleToggle3 = () => {
    setVolunteers(data[0].Volunteers)
    setOpen3(!open3);
  };
  const handleToggleReceiver = () => {
    setReceivers(data[0].Receivers)
    setOpenReceiver(!openReceiver);
  };
  const handleToggle4 = () => {
    setOpen4(!open4);
  };
  const handleToggle5 = () => {
    setOpen5(!open5);
  };
  const handleToggle6 = () => {
    setOpen6(!open6);
  };
  const handleToggle7 = () => {
    setOpen7(!open7);
    setMod([]);
  };
  const handleToggle8 = () => {
    setOpen8(!open8);
  };
  const changeU = (id) => {
    window.location.href = `/event/edit/${id}`;
  };
  const openCreditSplits = () => {

    window.location.href = `/event/creds/${id}`;
  };

  const addUser = () => {
    const body = [
      {
        from_username: userFirstName,
        from_user: userID,
        to_user: data[0].Founder,
        creds: '0',
        program_name: data[0].Title,
        program: data[0].EventID,
        hours: '0',
        message: `${user['first_name']} ${user['last_name']} wants to join your event ${data[0].Title}`,
        notif_type: 1,
      },
    ];
    dispatch(sendNotif(token, body, data[0].Founder));
    setDisable(true);
  };

  const founderCreditNotif = () => {
    const body1 = [
      {
        from_user: userID,
        to_user: 1,
        creds: creds,
        program_name: act['title'],
        program: act['id'],
        hours: creds,
        message: `${user['first_name']} ${user['last_name']} is requesting ${creds} contribution for participating in the program ${act['title']}`,
        notif_type: 5,
        from_username: `${user['first_name']} ${user['last_name']} (founder)`,
      },
    ];

    const body2 = [
      {
        from_user: userID,
        to_user: 1,
        creds: creds,
        program_name: act['title'],
        program: act['id'],
        hours: creds,
        message: `${user['first_name']} ${user['last_name']} is requesting ${creds} time credits for bank balance of the program ${act['title']}`,
        notif_type: 3,
        from_username: `${user['first_name']} ${user['last_name']} (founder)`,
      },
    ];


    if (value === 'credit_founder') {

      dispatch(sendNotif(token, body1, 1));
    } else {
      // console.log(body2)
      dispatch(sendNotif(token, body2, 1));
    }
  };

  const notif = () => {
    //console.log(inputList);
    //console.log(act['founder']);
    fetch(process.env.REACT_APP_API_URL + `/api/notif/send/${act['founder']}`, {
      method: 'POST',
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(inputList),
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data);
        toast.success('Request sent');
      });
  };

  const creditRequest = () => {

    fetch(process.env.REACT_APP_API_URL + '/api/user/credit-xchange', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        from_user: userID,
        to_user: act['founder'],
        creds: parseFloat(creds),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data);
        if (data.status === 200) {
          toast.success('Credits Sent');
        } else {
          toast.error('Credit Balance Insufficient');
        }

      });
  };

  const CreditExchange = () => {

    fetch(process.env.REACT_APP_API_URL + '/api/notif/send/bulk', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({
        members: selected,
        message: message,
        creds: creds,
        name: user['first_name'] + user['last_name'],
        prog_id: act['id'],
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data);
        if (data.status === 'success') {
          toast.success('Request Sent');
        } else {
          toast.error('Request Error');
        }

      });
  };

  const selectAll = () => {
    setAll(!All);

    let select = [];
    if (All) {
      volunteers.forEach((info) => {
        select.push(info.id);
      });
    } else {
      select = [];
    }

    // console.log(select);
    setSelected(select);
  };

  const selectAllReceivers = () => {
    setAllReceivers(!allReceivers);

    let select = [];
    if (allReceivers) {
      receivers.forEach((info) => {
        select.push(info.id);
      });
    } else {
      select = [];
    }

    // console.log(select);
    setSelectedReceivers(select);
  };

  const Add = (id, index) => {
    var check = checkedState;

    let select = selected;
    if (!selected.includes(id)) {
      select.push(id);
      check[index] = true;
    } else {
      let index = selected.indexOf(id);
      select.splice(index, 1);
      check[index] = false;
    }
    //console.log(select);
    //console.log(checkedState);

    setSelected(select);
  };

  const AddReceiver = (id, index) => {
    var check = receiverCheckedSate;

    let select = selectedReceivers;
    if (!selectedReceivers.includes(id)) {
      select.push(id);
      check[index] = true;
    } else {
      let index = selectedReceivers.indexOf(id);
      select.splice(index, 1);
      check[index] = false;
    }
    //console.log(select);
    //console.log(checkedState);

    setSelectedReceivers(select);
  };

  // const updateImage = (ev) => {
  //   ev.target.src = '/SCFrontend/public/blank.png'
  // }
  const SendBulkCredit = () => {


    if (!file) {
      fetch(process.env.REACT_APP_API_URL + `/api/act/credit/bulk`, {
        method: 'PUT',
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          users: selected,
          creds: parseFloat(creds),
          prog_id: act['id'],
          program_id: programid,
          event_id: eventID

        }),
      })
        .then((res) => res.json())
        .then((data) => {

          //console.log(data.status, "data.status");
          if (data.error === null && data.response.response_data[0].message === "success") {
            toast.success('Time Cred$ sent');
          } else {
            toast.error('Credit Balance insufficient');
          }

          setFile(null);
          handleToggle3();
        });
    } else {
      const formData = new FormData();
      formData.append('excel_file', file, file.name);
      //console.log(formData);
      fetch(process.env.REACT_APP_API_URL + `/api/excel/${act['id']}`, {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          //console.log(data);
          if (data['status'] === 'success') {
            toast.success('Time Cred$ sent');
          } else {
            toast.error('Credit Balance insufficient');
          }

          setFile(null);
          handleToggle3();
        });
    }
  };

  const SendBulkDebit = () => {


    if (!file) {
      fetch(process.env.REACT_APP_API_URL + `/api/act/debit/bulk`, {
        method: 'PUT',
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          users: selectedReceivers,
          debits: parseFloat(debits),
          prog_id: act['id'],
          program_id: programid,
          event_id: eventID

        }),
      })
        .then((res) => res.json())
        .then((data) => {

          //console.log(data.status, "data.status");
          if (data.error === null && data.response.response_data[0].message === "success") {
            toast.success('Time Cred$ sent');
          } else {
            toast.error('Credit Balance insufficient');
          }

          setFile(null);
          handleToggleReceiver();
        });
    } else {
      const formData = new FormData();
      formData.append('excel_file', file, file.name);
      //console.log(formData);
      fetch(process.env.REACT_APP_API_URL + `/api/excel/${act['id']}`, {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          //console.log(data);
          if (data['status'] === 'success') {
            toast.success('Time Cred$ sent');
          } else {
            toast.error('Credit Balance insufficient');
          }

          setFile(null);
          handleToggleReceiver();
        });
    }
  };

  const onFileChange = (event) => {
    // Update the state
    setFile(event.target.files[0]);
    //console.log(event.target.files[0]);
  };

  // const goto = () => {
  //   window.location.href = act['fund_links'];
  // };

  // const donate = () => {
  //   navigate({
  //     pathname: '/www.socialcred.in/donate',
  //     title: act['title'],
  //   });
  // };

  const profile = (id) => {
    if (userID !== parseInt(id)) {
      navigate(`/profile/${id}`);
    } else {
      navigate(`/profile`);
    }
  };

  const handleViewProgram=()=>{
    const programId = programid
    navigate(`/program/${programId}`);
  }
  function cardEventData(data) {
    let dataArray = []
    // console.log(data, userID);
    if (data) {

      for (let index = 0; index < data.length; index++) {
        dataArray.push(
          <CardContent style={{}} key={index}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={5}>
                <Grid container spacing={2}>
                  <Grid item xs={12} style={{ fontFamily: "Raleway" }}>
                    <Typography
                      component="h1"
                      style={{ fontSize: 38, fontFamily: "Raleway" }}
                    >
                      {data[index].Title}
                      {(userID===1 || parseInt(data[index].Founder) === userID) ? (
                        <Button
                          style={{
                            zIndex: 15,
                            borderRadius: 20,
                            width: 50,
                            fontFamily: "Raleway",
                          }}
                          onClick={() => {
                            changeU(data[index].EventID);
                          }}
                        >
                          <EditIcon style={{ zIndex: 10 }}></EditIcon>
                        </Button>
                      ) : (
                        ""
                      )}
                    </Typography>

                    {data[index].ServiceType !== "O" ? (
                      <Grid container spacing={1}>
                        <Grid
                          item
                          xs={12}
                          style={{
                            paddingBottom: "10px",
                            paddingRight: "10px",
                          }}
                        >
                          <Button
                            style={{
                              textTransform: "None",
                              backgroundColor:
                                config[process.env.REACT_APP_HOST_NAME].css
                                  .buttonColor,
                              color:
                                config[process.env.REACT_APP_HOST_NAME].css
                                  .buttonFontColor,
                              borderRadius: 20,
                              width: 100,
                              height: 40,
                              fontFamily: "Raleway",
                            }}
                            href="/donate"
                          >
                            Donate
                          </Button>
                        </Grid>

                        <Grid
                          container
                          alignItems="center"
                          style={{ paddingBottom: "5px" }}
                        >
                          <Grid item xs={12} lg={12}>
                            {token && data[index].Founder ? (
                            (userID===1 || [data[index].Founder].includes(parseInt(userID))) ? (( userID===1 || parseInt(data[index].Founder) === userID) ? 
                              (
                                  <>
                                    <Button
                                      style={{
                                        backgroundColor:
                                          config[
                                            process.env.REACT_APP_HOST_NAME
                                          ].css.buttonColor,
                                        fontFamily: "Raleway",
                                        color:
                                          config[
                                            process.env.REACT_APP_HOST_NAME
                                          ].css.buttonFontColor,
                                        borderRadius: 20,
                                        textTransform: "None",
                                        width: 160,
                                        height: 40,
                                        marginLeft: 5,
                                        marginRight: 5,
                                        marginBottom: 5,
                                      }}
                                      onClick={handleToggle3}
                                    >
                                      Credit Volunteers
                                    </Button>
                                    <Button
                                      style={{
                                        backgroundColor:
                                          config[
                                            process.env.REACT_APP_HOST_NAME
                                          ].css.buttonColor,
                                        fontFamily: "Raleway",
                                        color:
                                          config[
                                            process.env.REACT_APP_HOST_NAME
                                          ].css.buttonFontColor,
                                        borderRadius: 20,
                                        textTransform: "None",
                                        width: 160,
                                        height: 40,
                                        marginLeft: 5,
                                        marginRight: 5,
                                        marginBottom: 5,
                                      }}
                                      onClick={handleToggleReceiver}
                                    >
                                      Debit Receivers
                                    </Button>
                                  </>
                                ) : (
                                  <Button
                                    style={{
                                      backgroundColor:
                                        config[process.env.REACT_APP_HOST_NAME]
                                          .css.buttonColor,
                                      fontFamily: "Raleway",
                                      color:
                                        config[process.env.REACT_APP_HOST_NAME]
                                          .css.buttonFontColor,
                                      borderRadius: 20,
                                      textTransform: "None",
                                      width: 160,
                                      height: 40,
                                    }}
                                    onClick={handleToggle2}
                                  >
                                    Request for Cred$
                                  </Button>
                                )
                              ) : (
                                <Button
                                  onClick={addUser}
                                  style={{
                                    backgroundColor:
                                      config[process.env.REACT_APP_HOST_NAME]
                                        .css.buttonColor,
                                    fontFamily: "Raleway",
                                    color:
                                      config[process.env.REACT_APP_HOST_NAME]
                                        .css.buttonFontColor,
                                    borderRadius: 20,
                                    textTransform: "None",
                                    width: 160,
                                    height: 40,
                                    marginLeft: 5,
                                    marginRight: 5,
                                    marginBottom: 5,
                                  }}
                                  disabled={disable}
                                >
                                  Join Event
                                </Button>
                              )
                            ) : (
                              <Button
                                onClick={() =>
                                  (window.location.href = "/login")
                                }
                                style={{
                                  backgroundColor:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .buttonColor,
                                  fontFamily: "Raleway",
                                  color:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .buttonFontColor,
                                  borderRadius: 20,
                                  textTransform: "None",
                                  width: 160,
                                  height: 40,
                                  marginLeft: 5,
                                  marginRight: 5,
                                  marginBottom: 5,
                                }}
                                disabled={disable}
                              >
                                Join Event
                              </Button>
                            )}

                            {/* <Grid container alignItems="center" style={{ justifyContent: 'space-evenly', marginTop: window.innerWidth > 900 ? 0 : 5 }}> */}
                            <Button
                              style={{
                                backgroundColor:
                                  config[process.env.REACT_APP_HOST_NAME].css
                                    .buttonColor,
                                fontFamily: "Raleway",
                                color:
                                  config[process.env.REACT_APP_HOST_NAME].css
                                    .buttonFontColor,
                                borderRadius: 20,
                                textTransform: "None",
                                width: 160,
                                height: 40,
                                marginLeft: 5,
                                marginRight: 5,
                                marginBottom: 5,
                              }}
                              onClick={openCreditSplits}
                            >
                              Cred$ Splits
                            </Button>

                            <Button
                              style={{
                                backgroundColor:
                                  config[process.env.REACT_APP_HOST_NAME].css
                                    .buttonColor,
                                fontFamily: "Raleway",
                                color:
                                  config[process.env.REACT_APP_HOST_NAME].css
                                    .buttonFontColor,
                                borderRadius: 20,
                                textTransform: "None",
                                width: 160,
                                height: 40,
                                marginLeft: 5,
                                marginRight: 5,
                                marginBottom: 5,
                              }}
                              onClick={handleViewProgram}
                            >
                              View Program
                            </Button>
                          </Grid>
                        </Grid>
                        {/* </Grid> */}

                        <Grid item xs={12} sm={12} md={12}>
                          {" "}
                          <Typography
                            style={{
                              fontSize: 24,
                              marginTop: 10,
                              fontFamily: "Raleway",
                            }}
                          >
                            {" "}
                            Total Volunteers : {volCount}
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          {" "}
                          <Typography
                            style={{
                              fontSize: 24,
                              marginTop: 10,
                              fontFamily: "Raleway",
                            }}
                          >
                            {" "}
                            Total Receivers : {recCount}
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          {" "}
                          <Typography
                            style={{
                              fontSize: 24,
                              marginTop: 10,
                              fontFamily: "Raleway",
                            }}
                          >
                            {" "}
                            Time cred$ exchanged : {totalCredExchange}
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={12}>
                          {" "}
                          <Typography
                            style={{
                              fontSize: 24,
                              marginTop: 10,
                              fontFamily: "Raleway",
                            }}
                          >
                            {" "}
                            (Event Credit Balance: {data[index].Creds}){" "}
                          </Typography>{" "}
                        </Grid>
                        {/* {parseInt(data[index].Founder) === userID ? (
                          <Button
                            style={{
                              zIndex: 15,
                              borderRadius: 20,
                              fontFamily: 'Raleway',
                              marginTop: 10,
                              backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                              color: 'white',
                            }}
                            onClick={() => {
                              handleToggle8();
                            }}
                          >
                            Request as founder
                          </Button>
                        ) : (
                          ''
                        )} */}
                      </Grid>
                    ) : (
                      <Grid container>
                        <Button
                          style={{
                            textTransform: "None",
                            backgroundColor:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonColor,
                            color:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonFontColor,
                            borderRadius: 20,
                            width: 100,
                            height: 40,
                            fontFamily: "Raleway",
                          }}
                          href="/donate"
                        >
                          Donate
                        </Button>
                        &nbsp;
                        {data[index].UserId ? (
                          [data[index].UserId].includes(parseInt(userID)) ? (
                            parseInt(data[index].Founder) === userID ? (
                              <Button
                                style={{
                                  backgroundColor:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .buttonColor,
                                  fontFamily: "Raleway",
                                  color:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .buttonFontColor,
                                  borderRadius: 20,
                                  textTransform: "None",
                                  width: 160,
                                  height: 40,
                                }}
                                onClick={handleToggle4}
                              >
                                {" "}
                                Request for Cred$
                              </Button>
                            ) : (
                              <Button
                                style={{
                                  backgroundColor:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .buttonColor,
                                  fontFamily: "Raleway",
                                  color:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .buttonFontColor,
                                  borderRadius: 20,
                                  textTransform: "None",
                                  width: 160,
                                  height: 40,
                                }}
                                onClick={handleToggle5}
                              >
                                {" "}
                                Send Cred${" "}
                              </Button>
                            )
                          ) : (
                            <Root disabled={disable}></Root>
                          )
                        ) : (
                          ""
                        )}
                        {parseInt(data[index].Founder) === userID ? (
                          <Button
                            style={{
                              zIndex: 15,
                              borderRadius: 20,
                              width: 5,
                              fontFamily: "Raleway",
                            }}
                            onClick={() => {
                              changeU(data[index].EventID);
                            }}
                          >
                            <EditIcon style={{ zIndex: 10 }}></EditIcon>
                          </Button>
                        ) : (
                          ""
                        )}
                      </Grid>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Typography style={{ fontFamily: "Raleway" }}>
                      <strong>Donation Links</strong>
                    </Typography>
                    <Typography style={{ fontFamily: "Raleway" }}>
                      {" "}
                      {data[index].FundLinks}
                    </Typography>
                  </Grid>

                  {data[index].Community && (
                    <Grid item xs={4} md={6}>
                      <Typography style={{ fontFamily: "Raleway" }}>
                        {" "}
                        <strong> Community </strong>
                      </Typography>
                      <Typography
                        name="Description"
                        defaultValue="None"
                        style={{ fontFamily: "Raleway" }}
                      >
                        {data[index].Community}
                      </Typography>
                    </Grid>
                  )}
                  {data[index].Company && (
                    <Grid item xs={4} md={6}>
                      <Typography style={{ fontFamily: "Raleway" }}>
                        {" "}
                        <strong> Company </strong>
                      </Typography>
                      <Typography
                        name="Description"
                        defaultValue="None"
                        style={{ fontFamily: "Raleway" }}
                      >
                        {data[index].Company}
                      </Typography>
                    </Grid>
                  )}
                  {data[index].School && (
                    <Grid item xs={6} md={6}>
                      <Typography style={{ fontFamily: "Raleway" }}>
                        {" "}
                        <strong> School </strong>{" "}
                      </Typography>
                      <Typography
                        name="Description"
                        defaultValue="None"
                        style={{ fontFamily: "Raleway" }}
                      >
                        {data[index].School}
                      </Typography>
                    </Grid>
                  )}

                  <Grid item xs={6} md={6}>
                    <Typography style={{ fontFamily: "Raleway" }}>
                      {" "}
                      <strong> Location </strong>{" "}
                    </Typography>
                    <Typography
                      name="Description"
                      defaultValue="None"
                      style={{ fontFamily: "Raleway" }}
                    >
                      {data[index].Location}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography style={{ fontFamily: "Raleway" }}>
                      <strong> Donations Raised</strong>
                    </Typography>
                    <Typography style={{ fontFamily: "Raleway" }}>
                      {" "}
                      ₹{data[index].Donations}{" "}
                    </Typography>
                  </Grid>
                  {data[index].WhatsappLink ===
                  "https://www.temporary-url.com/" ? (
                    ""
                  ) : data[index].UserId ? (
                    [data[index].UserId].includes(parseInt(userID)) ? (
                      <Grid item xs={12}>
                        <Typography style={{ fontFamily: "Raleway" }}>
                          <strong>Whatsapp Group</strong>
                        </Typography>
                        <a href={data[index].WhatsappLink}>
                          {" "}
                          {data[index].WhatsappLink}
                        </a>{" "}
                      </Grid>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  <Grid item xs={12} md={12}>
                    <Typography style={{ fontFamily: "Raleway" }}>
                      <strong>{data[index].FounderName}'s Plan</strong>
                    </Typography>
                    <Typography
                      name="Description"
                      defaultValue="None"
                      style={{ fontFamily: "Raleway", wordWrap: "break-word" }}
                    >
                      {data[index].EventDescription}
                    </Typography>
                  </Grid>
                  {data[index].WhatDonating ? (
                    data[index].WhatDonating !== "x" ? (
                      <Grid item xs={12}>
                        <Grid item xs={12}>
                          <Typography style={{ fontFamily: "Raleway" }}>
                            {" "}
                            <strong>
                              What {data[index].FounderName} is donating
                            </strong>
                          </Typography>
                          <Typography
                            name="Description"
                            defaultValue="None"
                            style={{ fontFamily: "Raleway" }}
                          >
                            {data[index].WhatDonating}
                          </Typography>
                        </Grid>
                        <br></br>
                        <Grid item xs={12}>
                          <Typography style={{ fontFamily: "Raleway" }}>
                            {" "}
                            <strong>
                              {" "}
                              Where is the program taking place?{" "}
                            </strong>
                          </Typography>
                          <Typography
                            name="Description"
                            defaultValue="None"
                            style={{ fontFamily: "Raleway" }}
                          >
                            {data[index].WhereDonating}
                          </Typography>
                        </Grid>
                      </Grid>
                    ) : (
                      " "
                    )
                  ) : (
                    ""
                  )}
                  <Grid item xs={4} md={6}>
                    <Typography style={{ fontFamily: "Raleway" }}>
                      {" "}
                      <strong> Start Date </strong>
                    </Typography>
                    <Typography
                      name="Description"
                      defaultValue="None"
                      style={{ fontFamily: "Raleway" }}
                    >
                      {Moment(data[index].StartDate).format("DD MMM YYYY")}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography style={{ fontFamily: "Raleway" }}>
                      {" "}
                      <strong> Category </strong>{" "}
                    </Typography>
                    <Typography
                      name="Description"
                      defaultValue="None"
                      style={{ fontFamily: "Raleway" }}
                    >
                      {data[index].Category}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={6} xs={12}>
                {data[index].Image.length > 0 ? (
                  <Grid container>
                    <Grid item sm={12} xs={12} md={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          margin: "10px",
                        }}
                      >
                        <CorouselImages PhotoGallery={data[index].Image} />
                      </div>
                    </Grid>
                  </Grid>
                ) : parseInt(data[index].Founder) === userID ? (
                  <CardActionArea
                    onClick={() => {
                      changeU(data[index].EventID);
                    }}
                    style={{
                      textAlign: "center",
                      borderRadius: 30,
                      height: 300,
                    }}
                  >
                    {" "}
                    Add Event Images
                  </CardActionArea>
                ) : (
                  ""
                )}
              </Grid>

              {/* <Grid item xs={12} style={{ fontSize: 30 }}>
            {' '}
            Upcoming Events{' '}
            {parseInt(data[index].Founder) === userID ? (
              <Button onClick={handleToggle6}>ADD</Button>
            ) : (
              ''
            )}
          </Grid> */}
              {/* {events.length > 0 ? (
            <Grid container>
              <Grid
                container
                style={{
                  overflowY: 'auto',
                  maxHeight: 200,
                  marginTop: 10,
                }}
              >
                <Grid
                  item
                  style={{ textAlign: 'center', fontSize: 16 }}
                  md={3}
                  xs={3}
                >
                  <b>Title:</b>
                </Grid>
                <Grid item style={{ textAlign: 'center' }} md={2} xs={3}>
                  <b>Date:</b>
                </Grid>
                <Grid item style={{ textAlign: 'center' }} md={3} xs={3}>
                  <b>Start Time:</b>
                </Grid>
                <Grid item style={{ textAlign: 'center' }} md={2} xs={3}>
                  <b>End Time:</b>
                </Grid>
                {events.map((info, index) => {
                  return (
                    <Grid item xs={12}>
                      <Card>
                        <Grid item xs={12}>
                          <CardContent>
                            <Grid container>
                              <Grid
                                item
                                style={{ textAlign: 'center' }}
                                xs={3}
                              >
                                {info.title}{' '}
                              </Grid>
                              <Grid
                                item
                                style={{ textAlign: 'center' }}
                                xs={2}
                              >
                                {Moment(info.date).format(
                                  'DD MMM' + ', ' + 'YYYY'
                                )}{' '}
                              </Grid>
                              <Grid
                                item
                                style={{ textAlign: 'center' }}
                                xs={3}
                              >
                                {info.start_time}{' '}
                              </Grid>
                              <Grid
                                item
                                style={{ textAlign: 'center' }}
                                xs={2}
                              >
                                {info.end_time}{' '}
                              </Grid>
                              <Grid
                                item
                                style={{ textAlign: 'center' }}
                                md={1}
                                xs={12}
                              >
                                {parseInt(data[index].Founder) === userID ? (
                                  <Button
                                    onClick={() => {
                                      deleteEvent(info.id);
                                    }}
                                  >
                                    {' '}
                                    <DeleteIcon />{' '}
                                  </Button>
                                ) : !info.button_clicked.includes(
                                    parseInt(userID)
                                  ) ? (
                                  info.creds > 0 ? (
                                    getCurrentDate() === info.date ? (
                                      <Button
                                        style={{
                                          backgroundColor:
                                            info.earn_or_burn === 'earn'
                                              ? 'green'
                                              : 'red',
                                          color: 'white',
                                        }}
                                        onClick={() => {
                                          creditEvent(
                                            info.creds,
                                            info.earn_or_burn,
                                            info.id
                                          );
                                        }}
                                      >
                                        {' '}
                                        {info.earn_or_burn === 'earn'
                                          ? 'EARN'
                                          : 'BURN'}{' '}
                                      </Button>
                                    ) : (
                                      ''
                                    )
                                  ) : (
                                    ''
                                  )
                                ) : (
                                  ''
                                )}
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Grid>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          ) : (
            'No upcoming events'
          )} */}
              <Grid item xs={12} style={{ fontSize: 30 }}>
                Volunteer info
              </Grid>
              <Grid item xs={6} md={3} style={{}}>
                <Typography style={{ fontFamily: "Raleway" }}>
                  {" "}
                  <strong> Maximum Volunteers</strong>{" "}
                </Typography>
                <Typography>{data[index].VolReq}</Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography style={{ fontFamily: "Raleway" }}>
                  {" "}
                  <strong> Maximum Receivers</strong>{" "}
                </Typography>
                <Typography>{data[index].ReceiversCount}</Typography>
              </Grid>
              {/* <Grid item xs={12} md={3}>
                <Typography style={{ fontFamily: 'Raleway' }}>
                  {' '}
                  <strong>  Current Number of Volunteers: </strong>{' '}
                </Typography>
                <Typography>{data[index].User ? [data[index].User].length : 1}</Typography>
              </Grid> */}
              {members.length > 1 ? (
                <Grid container>
                  <Grid item xs={12}>
                    List of Volunteers:-{" "}
                  </Grid>
                  <Grid container style={{ overflowY: "auto", maxHeight: 350 }}>
                    {members.map((info, index) => {
                      return (
                        <Grid item xs={12} key={index}>
                          <Card>
                            <CardActionArea
                              onClick={() => {
                                profile(info.id);
                              }}
                            >
                              <CardContent>
                                <span>
                                  {info.first_name} {info.last_name}
                                </span>
                              </CardContent>
                            </CardActionArea>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              ) : (
                ""
              )}

              <Grid item xs={6} md={12}>
                <Typography
                  style={{ fontFamily: "Raleway", fontWeight: "bold" }}
                >
                  Founder
                </Typography>
                <Button
                  style={{ textTransform: "None", borderRadius: 30 }}
                  onClick={() => {
                    profile(data[index].Founder);
                  }}
                >
                  <img
                    alt={"founder_profile_pic"}
                    className="responsive"
                    style={{ borderRadius: 30, height: 30, paddingRight: 4 }}
                    src={data[index].FounderProfilePic}
                  />
                  &nbsp;{data[index].FounderName}{" "}
                </Button>
              </Grid>

              <Backdrop className={classes.backdrop} open={open2}>
                <Grid
                  container
                  style={{
                    backgroundColor: "#ffffff",
                    overflowY: "auto",
                    color: "black",
                    textAlign: "center",
                    borderRadius: 30,
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <br></br>
                    <Typography style={{ fontSize: 28, fontFamily: "Raleway" }}>
                      {" "}
                      Submit report(s) below{" "}
                    </Typography>
                    <br></br>
                  </Grid>
                  <Grid item xs={12}>
                    <div
                      style={{
                        overflowY: "auto",
                        overflowX: "hidden",
                        height: 300,
                      }}
                    >
                      {inputList.map((x, i) => {
                        return (
                          <Grid
                            container
                            style={{ textAlign: "center" }}
                            key={i}
                          >
                            <Grid item xs={12}>
                              <br></br>
                            </Grid>
                            <Grid item md={1}></Grid>
                            <Grid item xs={12} md={3}>
                              <Typography>Clocked hours </Typography>
                              <TextField
                                name="clocked_hours"
                                placeholder="Clocked Hours"
                                value={x.clocked_hours}
                                variant="outlined"
                                type="number"
                                inputProps={{ min: 0 }}
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <Typography>Your contribution</Typography>
                              <TextField
                                className="ml10"
                                name="message"
                                placeholder="Message"
                                value={x.message}
                                variant="outlined"
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <Typography>Date of Clocked Hours</Typography>
                              <TextField
                                className="ml10"
                                type="date"
                                name="date"
                                placeholder="Date of Clocked hours"
                                value={x.date}
                                variant="outlined"
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </Grid>

                            <Grid item xs={12} md={1}>
                              <div className="btn-box">
                                <br></br>
                                {inputList.length !== 1 && (
                                  <Button
                                    className="mr10"
                                    onClick={() => handleRemoveClick(i)}
                                  >
                                    remove
                                  </Button>
                                )}
                                {inputList.length - 1 === i && (
                                  <Button onClick={handleAddClick}>Add</Button>
                                )}
                                <br></br>
                              </div>
                            </Grid>
                            <Grid item xs={12}>
                              <br></br>{" "}
                            </Grid>
                            <br></br>
                          </Grid>
                        );
                      })}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <br></br>
                    <Button
                      onClick={notif}
                      style={{
                        backgroundColor:
                          config[process.env.REACT_APP_HOST_NAME].css
                            .buttonColor,
                        fontFamily: "Raleway",
                        color:
                          config[process.env.REACT_APP_HOST_NAME].css
                            .buttonFontColor,
                        borderRadius: 20,
                        textTransform: "None",
                        width: 160,
                        height: 40,
                        marginTop: window.innerWidth > 900 ? 0 : 5,
                        marginLeft: 5,
                        marginRight: 5,
                      }}
                    >
                      submit
                    </Button>
                    &nbsp;
                    <Button
                      style={{
                        backgroundColor:
                          config[process.env.REACT_APP_HOST_NAME].css
                            .buttonColor,
                        fontFamily: "Raleway",
                        color:
                          config[process.env.REACT_APP_HOST_NAME].css
                            .buttonFontColor,
                        borderRadius: 20,
                        textTransform: "None",
                        width: 160,
                        height: 40,
                        marginTop: window.innerWidth > 900 ? 0 : 5,
                        marginLeft: 5,
                        marginRight: 5,
                      }}
                      onClick={handleClose}
                    >
                      cancel
                    </Button>
                    <br></br>
                    <br></br>
                  </Grid>
                </Grid>
              </Backdrop>

              <Backdrop className={classes.backdrop} open={open3} sx={{
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                  padding: '5vw'
                }}>
                <Grid
                  container
                  style={{
                    backgroundColor: "#ffffff",
                    overflowY: "auto",
                    color: "black",
                    textAlign: "left",
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Grid item xs={12}>
                          <Typography
                            style={{
                              textAlign: "center",
                              fontFamily: "Raleway",
                              fontSize: 20,
                            }}
                          >
                            Select Members and Enter the Credits below
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={12}>
                          <input
                            type="checkbox"
                            onClick={() => {
                              selectAll();
                            }}
                          ></input>
                          <span>Select All</span>
                        </Grid>
                        {All ? (
                          <Grid
                            container
                            style={{ overflowY: "auto", maxHeight: 350 }}
                          >
                            {volunteers
                              ? volunteers.map(
                                  ({ id, first_name, last_name }, index) => {
                                    //console.log('list2');

                                    return (
                                      <Grid item xs={12} key={index}>
                                        <Card>
                                          <CardContent>
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                Add(id, index);
                                              }}
                                            ></input>
                                            <span>
                                              {first_name} {last_name}
                                            </span>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    );
                                  }
                                )
                              : ""}
                          </Grid>
                        ) : (
                          ""
                        )}

                        <Grid container style={{ marginTop: 10 }}>
                          <br />
                          <Typography>Enter Credits: </Typography>
                          <Input
                            variant="outlined"
                            size="small"
                            input="number"
                            onChange={(e) => {
                              setCreds(e.target.value);
                            }}
                          ></Input>
                        </Grid>

                        {/* <Typography> OR </Typography>
                    <Typography>
                      Upload Zoom Call Report:
                      <Tooltip
                        title='If you have a zoom business account, generate the attendance report for your zoom call and upload! (EVERYONE MUST LOGIN TO ZOOM WITH THE SAME EMAIL ID AS GIFT OF TIME'
                        arrow
                      >
                        <InfoIcon style={{ color: '#FF8800' }} />
                      </Tooltip>
                    </Typography>
                    <input
                      type='file'
                      accept='.csv'
                      name='file'
                      onChange={onFileChange}
                    /> */}

                        <br />
                        <Button
                          style={{
                            backgroundColor:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonColor,
                            fontFamily: "Raleway",
                            color:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonFontColor,
                            borderRadius: 20,
                            textTransform: "None",
                            width: 160,
                            height: 40,
                            marginTop: window.innerWidth > 900 ? 0 : 5,
                            marginLeft: 5,
                            marginRight: 5,
                          }}
                          onClick={() => {
                            SendBulkCredit();
                          }}
                        >
                          Submit
                        </Button>
                        <Button
                          style={{
                            backgroundColor:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonColor,
                            fontFamily: "Raleway",
                            color:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonFontColor,
                            borderRadius: 20,
                            textTransform: "None",
                            width: 160,
                            height: 40,
                            marginTop: window.innerWidth > 900 ? 0 : 5,
                            marginLeft: 5,
                            marginRight: 5,
                          }}
                          onClick={handleToggle3}
                        >
                          Cancel
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Backdrop>
              <Backdrop className={classes.backdrop} open={openReceiver} sx={{
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                  padding: '5vw'
                }}>
                <Grid
                  container
                  style={{
                    backgroundColor: "#ffffff",
                    overflowY: "auto",
                    color: "black",
                    textAlign: "left",
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Grid item xs={12}>
                          <Typography
                            style={{
                              textAlign: "center",
                              fontFamily: "Raleway",
                              fontSize: 20,
                            }}
                          >
                            Select members and enter debits below
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={12}>
                          <input
                            type="checkbox"
                            onClick={() => {
                              selectAllReceivers();
                            }}
                          ></input>
                          <span>Select All</span>
                        </Grid>
                        {allReceivers ? (
                          <Grid
                            container
                            style={{ overflowY: "auto", maxHeight: 350 }}
                          >
                            {receivers
                              ? receivers.map(
                                  ({ id, first_name, last_name }, index) => {
                                    //console.log('list2');

                                    return (
                                      <Grid item xs={12} key={index}>
                                        <Card>
                                          <CardContent>
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                AddReceiver(id, index);
                                              }}
                                            ></input>
                                            <span>
                                              {first_name} {last_name}
                                            </span>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    );
                                  }
                                )
                              : ""}
                          </Grid>
                        ) : (
                          ""
                        )}

                        <Grid container style={{ marginTop: 10 }}>
                          <br />
                          <Typography>Enter Credits: </Typography>
                          <Input
                            variant="outlined"
                            size="small"
                            input="number"
                            onChange={(e) => {
                              setDebits(e.target.value);
                            }}
                          ></Input>
                        </Grid>

                        <br />
                        <Button
                          style={{
                            backgroundColor:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonColor,
                            fontFamily: "Raleway",
                            color:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonFontColor,
                            borderRadius: 20,
                            textTransform: "None",
                            width: 160,
                            height: 40,
                            marginTop: window.innerWidth > 900 ? 0 : 5,
                            marginLeft: 5,
                            marginRight: 5,
                          }}
                          onClick={() => {
                            SendBulkDebit();
                          }}
                        >
                          Submit
                        </Button>
                        <Button
                          style={{
                            backgroundColor:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonColor,
                            fontFamily: "Raleway",
                            color:
                              config[process.env.REACT_APP_HOST_NAME].css
                                .buttonFontColor,
                            borderRadius: 20,
                            textTransform: "None",
                            width: 160,
                            height: 40,
                            marginTop: window.innerWidth > 900 ? 0 : 5,
                            marginLeft: 5,
                            marginRight: 5,
                          }}
                          onClick={handleToggleReceiver}
                        >
                          Cancel
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Backdrop>
              <Backdrop className={classes.backdrop} open={open4} sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}>
                <Grid
                  container
                  style={{
                    backgroundColor: "#ffffff",
                    overflowY: "auto",
                    color: "black",
                    textAlign: "left",
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Grid item xs={12}>
                          <Typography
                            style={{
                              textAlign: "center",
                              fontFamily: "Raleway",
                              fontSize: 20,
                            }}
                          >
                            {"select_members_and_request_the_credits_below"}
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={12}>
                          <input
                            type="checkbox"
                            onClick={() => {
                              selectAllReceivers();
                            }}
                          ></input>
                          <span>Select All</span>
                        </Grid>

                        <Grid
                          container
                          style={{ overflowY: "auto", height: 350 }}
                        >
                          {members
                            ? members.map(
                                ({ id, first_name, last_name }, index) => {
                                  //console.log('list2');
                                  if (parseInt(id) !== userID) {
                                    return (
                                      <Grid item xs={12} key={index}>
                                        <Card>
                                          <CardContent>
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                Add(id, index);
                                              }}
                                            ></input>
                                            <span>
                                              {first_name} {last_name}
                                            </span>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    );
                                  } else {
                                    return <div key={index}></div>;
                                  }
                                }
                              )
                            : ""}
                        </Grid>

                        <Grid container style={{ marginTop: 10 }}>
                          <br />
                          <Typography>Enter Credits: </Typography>
                          <Input
                            variant="outlined"
                            size="small"
                            input="number"
                            onChange={(e) => {
                              setCreds(e.target.value);
                            }}
                          ></Input>

                          <Typography>Reason:</Typography>
                          <Input
                            variant="outlined"
                            size="small"
                            input="text"
                            onChange={(e) => {
                              setMessage(e.target.value);
                            }}
                          ></Input>
                        </Grid>

                        <Typography> OR </Typography>
                        <Typography>
                          Upload Zoom Call Report:
                          <Tooltip
                            title="If you have a zoom business account, generate the attendance report for your zoom call and upload! (EVERYONE MUST LOGIN TO ZOOM WITH"
                            arrow
                          >
                            <InfoIcon style={{ color: "#FF8800" }} />
                          </Tooltip>
                        </Typography>
                        <input
                          type="file"
                          accept=".csv"
                          name="file"
                          onChange={onFileChange}
                        />

                        <br />

                        {!file ? (
                          <Button
                            onClick={() => {
                              CreditExchange();
                            }}
                          >
                            submit
                          </Button>
                        ) : (
                          ""
                        )}
                        {file ? (
                          <Button
                            onClick={() => {
                              getReportList();
                            }}
                          >
                            Review
                          </Button>
                        ) : (
                          " "
                        )}
                        <Button onClick={handleToggle4}>Cancel</Button>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Backdrop>

              <Backdrop className={classes.backdrop} open={open5} sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}>
                <Grid
                  container
                  style={{
                    backgroundColor: "#ffffff",
                    overflowY: "auto",
                    color: "black",
                    textAlign: "left",
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Grid container style={{ marginTop: 10 }}>
                          <br />
                          <Typography>Enter Credits: </Typography>
                          <Input
                            variant="outlined"
                            size="small"
                            input="number"
                            onChange={(e) => {
                              setCreds(e.target.value);
                            }}
                          ></Input>
                        </Grid>

                        <br />
                        <Button
                          onClick={() => {
                            creditRequest();
                          }}
                        >
                          submit
                        </Button>
                        <Button onClick={handleToggle5}>Cancel</Button>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Backdrop>

              <Backdrop className={classes.backdrop} open={open6}>
                <Grid
                  container
                  style={{
                    backgroundColor: "#ffffff",
                    overflowY: "auto",
                    color: "black",
                    textAlign: "left",
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <Card>
                      {/* <MuiPickersUtilsProvider utils={DateFnsUtils}> */}
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <CardContent>
                          <Typography
                            style={{ textAlign: "center", fontSize: 30 }}
                          >
                            CREATE AN EVENT{" "}
                          </Typography>
                          <Grid container spacing={2} style={{ marginTop: 10 }}>
                            <br />

                            <Grid item md={4} xs={12}>
                              <Typography> Name of the event </Typography>
                              <Input
                                variant="outlined"
                                size="small"
                                name="title"
                                input="text"
                                onChange={handleChange}
                              ></Input>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography>
                                {" "}
                                "When will the event take place?"
                              </Typography>
                              <TextField
                                id="date"
                                name="date"
                                inputProps={{ min: getCurrentDate() }}
                                type="date"
                                style={{ width: 300 }}
                                size="small"
                                variant="outlined"
                                onChange={handleChange}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <TextField
                                id="time"
                                name="start_time"
                                label="Start time of the event"
                                type="time"
                                defaultValue="07:30"
                                style={{ width: 200 }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onChange={handleChange}
                                inputProps={{
                                  step: 300,
                                  // 5 min
                                }}
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <TextField
                                id="time"
                                name="end_time"
                                label="End time of the event"
                                type="time"
                                defaultValue="07:30"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onChange={handleChange}
                                style={{ width: 200 }}
                                inputProps={{
                                  step: 300,
                                  min: formData.start_time, // 5 min
                                }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <RadioGroup
                                aria-label="gender"
                                name="gender1"
                                value={value}
                                onChange={handleChange1}
                              >
                                <Grid container>
                                  <Grid item md={12}>
                                    <br />
                                    <Typography
                                      style={{
                                        textAlign: "left",
                                        fontSize: 20,
                                        fontFamily: "Raleway",
                                      }}
                                    >
                                      {" "}
                                      Will this event allow participants to earn
                                      or burn credits ?{" "}
                                    </Typography>
                                  </Grid>

                                  <FormControlLabel
                                    value="earn"
                                    control={<Radio color="primary" />}
                                    label="Earn"
                                    labelPlacement="end"
                                    onClick={() => {
                                      setValue("earn");
                                    }}
                                  />

                                  <FormControlLabel
                                    value="burn"
                                    control={<Radio color="primary" />}
                                    label="Burn"
                                    labelPlacement="end"
                                    onClick={() => {
                                      setValue("burn");
                                    }}
                                  />
                                </Grid>
                              </RadioGroup>
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                id="creds"
                                name="creds"
                                label="Creditss"
                                type="number"
                                defaultValue="0"
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                                style={{ width: 200 }}
                                inputProps={{
                                  step: 0.25,
                                  min: 0, // 5 min
                                }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Checkbox
                                variant="outlined"
                                name="is_recurring"
                                size="small"
                                type="checkbox"
                                onChange={() => {
                                  setisRecurring(!isRecurring);
                                }}
                              >
                                {" "}
                              </Checkbox>{" "}
                              Is this a recurring event?
                            </Grid>
                          </Grid>

                          <br />
                          <Button onClick={CreateEvent}>Submit</Button>
                          <Button onClick={handleToggle6}>Cancel</Button>
                        </CardContent>
                        </LocalizationProvider>
                    </Card>
                  </Grid>
                </Grid>
              </Backdrop>

              <Backdrop className={classes.backdrop} open={open7}>
                <Grid
                  container
                  style={{
                    backgroundColor: "#ffffff",
                    overflowY: "auto",
                    color: "black",
                    textAlign: "left",
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Grid container style={{ marginTop: 10 }}>
                          By default,everyone will be debited.
                          <br />
                          Please choose the moderators of the call to get
                          credited
                          {name.map((info, index) => {
                            return (
                              <div key={index}>
                                <Checkbox
                                  onChange={() => {
                                    addModerator(index);
                                  }}
                                />
                                {info}
                              </div>
                            );
                          })}
                        </Grid>

                        <br />
                        <Button
                          onClick={() => {
                            zoom_call_debit();
                          }}
                        >
                          submit
                        </Button>
                        <Button onClick={handleToggle7}>Cancel</Button>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Backdrop>

              <Backdrop className={classes.backdrop} open={open8}>
                <Grid
                  container
                  style={{
                    backgroundColor: "#ffffff",
                    overflowY: "auto",
                    color: "black",
                    textAlign: "left",
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Grid container style={{ marginTop: 10 }}>
                          Enter number of credits
                          <TextField
                            type="number"
                            onChange={(e) => {
                              setCreds(e.target.value);
                            }}
                          />
                          <Grid item xs={12}>
                            <RadioGroup aria-label="gender" name="gender1">
                              <Grid container>
                                <Grid item xs={12}>
                                  <Typography
                                    style={{
                                      textAlign: "left",
                                      fontSize: 20,
                                      marginTop: 12,
                                      fontFamily: "Raleway",
                                    }}
                                  >
                                    {" "}
                                    What would you like to do?{" "}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    value="credit_program"
                                    control={<Radio color="primary" />}
                                    label="Credits for program"
                                    labelPlacement="end"
                                    onClick={() => {
                                      setValue("credit_program");
                                    }}
                                  />
                                </Grid>
                                <Grid item md={12}>
                                  <FormControlLabel
                                    value="credit_founder"
                                    control={<Radio color="primary" />}
                                    label="Credits for founder"
                                    labelPlacement="end"
                                    onClick={() => {
                                      setValue("credit_founder");
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </RadioGroup>
                          </Grid>
                        </Grid>

                        <br />
                        <Button
                          onClick={() => {
                            founderCreditNotif();
                          }}
                        >
                          submit
                        </Button>
                        <Button onClick={handleToggle8}>Cancel</Button>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Backdrop>
              {/* <PhotoGallery PhotoGallery={data[index].Image}/> */}
              {/* <CorouselImages PhotoGallery={data[index].Image} /> */}
            </Grid>
          </CardContent>
        );

      }
      return dataArray
    }
  }
  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + `/api/events/eventid/list/view?event_id=${id}`, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.response.response_data)
        setRecCount(data.response.response_data[0].TotalReceivers)
        setVolCount(data.response.response_data[0].TotalVolunteers)
        setTotalCredExchange(data.response.response_data[0].TotalCreds);
        setEventId(data.response.response_data[0].EventID)
        setProgramId(data.response.response_data[0].ProgramId)
        setisLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  if (!isLoading) {
    return (
      <div style={{ padding: '1vw' }}>
        <Card
          variant='outlined'
          style={{
            marginTop: 10,
            backgroundColor: '#ffffff',
            zIndex: 10,
            borderRadius: 30,

          }}
        >
          {
            cardEventData(data)
          }
        </Card>
      </div>
    );
  } else {
    return (
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />
      </div>
    );
  }

}